import "./Loader.css";
export const Loader = () => {
  return (
    <div className="cls-spinner">
      <div className="cls-circle cls-spin"></div>
    </div>
  );
};
